import React from "react";
import MonthlyTimeTable from "./MonthlyTimeTable";


const JanuaryTimeTable = ({districtDetails }) => {
  return <MonthlyTimeTable month={1} title="January Namaz Time Table" columnKey="12Columns" districtDetails={districtDetails} />;
};

export default JanuaryTimeTable;
